<template>
  <div class="page-wrapper storybook-cnc-radio-button-group">
    <StorybookTemplate title="CncRadioButtonGroup" pathComponent="/shared/elements/global/v1/CncRadioButtonGroup.vue" :pathFigma="pathFigma" :desc="desc" :propList="propList" :form.sync="form">
      <CncRadioButtonGroup v-bind="form">{{ form.name }}</CncRadioButtonGroup>
    </StorybookTemplate>
  </div>
</template>

<script>
export default {
  components: {
    StorybookTemplate: () => import('../../../../components/StorybookTemplate.vue')
  },
  data () {
    return {
      pathFigma: 'https://www.figma.com/file/QGmzH850ARJRAeL8BuBAer/%5BWEB%5D-Shared-Components?type=design&node-id=3447%3A28098&mode=design&t=K4BoXeFmbltGwIwI-1',
      desc: 'วิธีการใช้ CncRadioButtonGroup ใน form สามารถใช้ <CncRadioButtonGroup/> แทน <el-checkbox-group/> ได้เลย จะเปรียบเสมือนตัว Ui ของ el-radio-group แต่จะพิเศษจากตัวเดิมตรงที่สามารถใส่ title, desc และสามารถ cuttom icon ได้ ส่วน error การ validate from สามารถ ใส่ได้ที่ error message ได้ที่ prop หรือ จะใช้งานแบบเดิม (rules form)',
      propList: [
        { name: 'title', type: 'input', param: 'title' },
        { name: 'desc', type: 'input', param: 'desc' },
        { name: 'errMessage', type: 'input', param: 'errMessage', default: '' },
        {
          name: 'size',
          type: 'select',
          param: 'size',
          default: 'medium',
          option: [
            { label: 'medium', name: 'Medium' },
            { label: 'small', name: 'Small' }
          ]
        },
        {
          name: 'rightIcon',
          type: 'object',
          param: 'rightIcon',
          objectKey: [
            { key: 'name', type: 'input', value: 'info' },
            { key: 'type', value: 'svg', type: 'select', option: ['svg', 'icon'] }
          ]
        },
        { name: 'disabled', type: 'boolean', param: 'disabled' },
        { name: 'isError', type: 'boolean', param: 'isError' },
        {
          name: 'orientation',
          type: 'select',
          param: 'orientation',
          default: 'vertical',
          option: [
            { label: 'vertical', name: 'Vertical' },
            { label: 'horizontal', name: 'Horizontal' }
          ]
        }
      ],
      form: {
        title: 'Radio Button',
        desc: 'This is a description.',
        errMessage: 'This is an error message.',
        rightIcon: { type: 'icon', name: 'info' },
        size: 'medium',
        disabled: false,
        isError: false,
        selected: 'Choice 1',
        orientation: 'Vertical',
        choices: [
          { id: 1, label: 'Choice 1', name: 'Choice 1' },
          { id: 2, label: 'Choice 2', name: 'Choice 2' },
          { id: 3, label: 'Choice 3', name: 'Choice 3' },
          { id: 4, label: 'Choice 4', name: 'Choice 4' }
        ]
      }
    }
  }
}
</script>
